<template>
  <app-board :header="false" class="mb-3">
    <!--<el-radio-group style="margin-bottom: 30px;" v-model="tabPosition">
      <el-radio-button label="top2">top2</el-radio-button>
      <el-radio-button label="right">right</el-radio-button>
      <el-radio-button label="bottom">bottom</el-radio-button>
      <el-radio-button label="left">left</el-radio-button>
    </el-radio-group>-->

    <el-tabs @tab-click="handleClick" tab-position="left" v-model="selectedTab">
      <el-tab-pane :lazy="true" class="p-4" label="Upload Document" name="uploadDocument">
        <div v-if="routeTabName === 'uploadDocument'">
          <uploadDocumentRate :editMode="false"></uploadDocumentRate>
        </div>
      </el-tab-pane>

      <el-tab-pane :lazy="true" label="Manual Rate" name="manualRate">
        <div v-if="routeTabName === 'manualRate'">
          <manualRate :editMode="false"></manualRate>
        </div>
      </el-tab-pane>

      <el-tab-pane :lazy="true" label="View Rates" name="viewRates">
        <div v-if="routeTabName === 'viewRates'">
          <viewRates :editMode="false"></viewRates>
        </div>
      </el-tab-pane>

      <!--<el-tab-pane label="Reports">

      </el-tab-pane>-->
    </el-tabs>
  </app-board>
</template>
<script>
export default {
  components: {
    uploadDocumentRate: () => import('./../upload-document-rate/View.vue'),
    manualRate: () => import('./../manual-rate/View.vue'),
    viewRates: () => import('./../view-rates/View.vue')
  },
  methods: {
    handleClick(tab, event) {
      let tabName = tab.$props.name
      this.$router.push({name: 'module->voip-mrt-vendor->rates-panel->tab', params: {tabName: tabName}})
    }
  },
  data() {
    return {
      routeTabName: this.$route.params.tabName,
      tabPosition: 'left',
      selectedTab: this.$route.params.tabName
    };
  }
};
</script>
